"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedPiece = useSelectedPiece;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const sessionContext_1 = require("~/game/sessionContext");
function useSelectedPiece() {
    const selectedPieceId = (0, react_redux_1.useSelector)((state) => state.game.ui.selectedPieceId);
    const { pieceRegistry } = (0, sessionContext_1.useGameSession)();
    return (0, react_1.useMemo)(() => {
        if (!selectedPieceId) {
            return null;
        }
        return pieceRegistry.getPieceById(selectedPieceId);
    }, [selectedPieceId, pieceRegistry]);
}
